(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    const wishlistButton = document.getElementById('custom-wishlist-button');

  if (wishlistButton) {
    const label = wishlistButton.querySelector('.wishlist-button__label');

    const updateWishlistLabel = () => {
      if (!label) return;

      const isAdded = wishlistButton.getAttribute('aria-pressed') === 'true';
      label.textContent = isAdded ? 'ADDED TO WISHLIST' : 'ADD TO WISHLIST';
    };

    updateWishlistLabel();

    new MutationObserver(updateWishlistLabel).observe(wishlistButton, {
      attributes: true,
      attributeFilter: ['aria-pressed'],
    });
  }
  } catch(e) { console.error(e); }
})();

})();
